// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea369862","453":"47886aa8","455":"b55893b0"}[chunkId] + ".chunk.js";
};